import React from "react";
import { CONTRACT_TYPES } from "../../../util";
import MultiSelectDropdown from "./base/MultiSelectDropdown";

const allOptions = Object.values(CONTRACT_TYPES);
const options = allOptions.map((type) => ({
  label: `app.enuns.${type}`,
  value: type,
}));

const ContractTypes = ({ value, onChange }) => {
  return (
    <>
      <MultiSelectDropdown
        title="app.contractTypes"
        values={options}
        defaultSelected={allOptions}
        onChange={onChange}
      />
    </>
  );
};

export default ContractTypes;
